// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var AmountCents = function (x) {
    return x;
};
var tsBridgeAmountCents = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedNumberType("AmountCents")("__brandAmountCents"));
    }
};
var writeAmountCents = Simple_JSON.writeForeignNumber;
var unwrap = function (v) {
    return v;
};
var showAmountCents = Data_Show.showNumber;
var readAmountCents = Simple_JSON.readNumber;
var ordAmountCents = Data_Ord.ordNumber;
var newtypeAmountCents = {
    Coercible0: function () {
        return undefined;
    }
};
var makeAmountCents = AmountCents;
var eqAmountCents = Data_Eq.eqNumber;
export {
    AmountCents,
    makeAmountCents,
    unwrap,
    newtypeAmountCents,
    eqAmountCents,
    ordAmountCents,
    showAmountCents,
    readAmountCents,
    writeAmountCents,
    tsBridgeAmountCents
};
//# sourceMappingURL=index.js.map
